import BenchlingConfig from 'BenchlingConfig';

export function isPointMaskingEnabled(): boolean {
  return BenchlingConfig.INSIGHTS_ENABLE_POINT_MASKING;
}
